// import React, { useState, useRef, useCallback } from 'react';
// import EmployeeDetailDrawer from './EmployeeDetailDrawer';
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   Collapse,
//   IconButton,
//   Button,
//   Grid,
//   Card,
//   useTheme,
//   useMediaQuery,
//   List,
//   ListItem,
//   Divider,
//   Avatar,
//   SwipeableDrawer,
//   Fab,
//   Zoom,
//   Badge
// } from '@mui/material';
// import {
//   Business,
//   KeyboardArrowDown,
//   KeyboardArrowUp,
//   Close,
//   Visibility,
//   People,
//   TrendingUp,
//   AccessTime,
//   Person,
//   ArrowUpward,
//   CheckCircle,
//   Cancel,
//   LocationOn
// } from '@mui/icons-material';

// // ─── Helpers ────────────────────────────────────────────────────────────────
// const isPresent = (emp) => emp.inn && emp.inn !== 'NR' && emp.inn !== '';

// // ─── Mobile: Single Location Panel ──────────────────────────────────────────
// const MobileLocationPanel = React.memo(({ location, employees, isExpanded, onToggle, onViewAll, onEmployeeClick }) => {
//   const strength = employees.length;
//   const present = employees.filter(isPresent).length;
//   const absent = strength - present;
//   const rate = strength > 0 ? Math.round((present / strength) * 100) : 0;
//   const rateColor = rate >= 80 ? '#16a34a' : rate >= 60 ? '#d97706' : '#dc2626';

//   return (
//     <Box sx={{ mb: 1.5 }}>
//       {/* ── Location Header Row (always visible) ── */}
//       <Box
//         onClick={() => onToggle(location)}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: 1.5,
//           px: 2,
//           py: 1.5,
//           bgcolor: isExpanded ? '#330066' : '#fff',
//           border: '1.5px solid',
//           borderColor: isExpanded ? '#330066' : '#e2e8f0',
//           borderRadius: isExpanded ? '14px 14px 0 0' : '14px',
//           cursor: 'pointer',
//           transition: 'all 0.25s ease',
//           userSelect: 'none',
//         }}
//       >
//         {/* Icon */}
//         <Avatar
//           sx={{
//             width: 36,
//             height: 36,
//             bgcolor: isExpanded ? 'rgba(255,255,255,0.2)' : '#e8f0fe',
//             flexShrink: 0,
//           }}
//         >
//           <LocationOn sx={{ fontSize: 18, color: isExpanded ? '#fff' : '#330066' }} />
//         </Avatar>

//         {/* Name */}
//         <Typography
//           sx={{
//             flex: 1,
//             fontWeight: 700,
//             fontSize: '0.88rem',
//             color: isExpanded ? '#fff' : '#1e293b',
//             lineHeight: 1.3,
//           }}
//         >
//           {location}
//         </Typography>

//         {/* Stats pills */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0 }}>
//           <Chip
//             icon={<People sx={{ fontSize: '13px !important', color: isExpanded ? '#fff !important' : '#330066 !important' }} />}
//             label={strength}
//             size="small"
//             sx={{
//               height: 24,
//               fontSize: '0.72rem',
//               fontWeight: 700,
//               bgcolor: isExpanded ? 'rgba(255,255,255,0.18)' : '#e8f0fe',
//               color: isExpanded ? '#fff' : '#330066',
//               '& .MuiChip-icon': { ml: '4px' },
//             }}
//           />
//           <Chip
//             label={`${rate}%`}
//             size="small"
//             sx={{
//               height: 24,
//               fontSize: '0.72rem',
//               fontWeight: 700,
//               bgcolor: isExpanded ? 'rgba(255,255,255,0.18)' : `${rateColor}18`,
//               color: isExpanded ? '#fff' : rateColor,
//             }}
//           />
//         </Box>

//         {/* Chevron */}
//         <Box
//           sx={{
//             flexShrink: 0,
//             transition: 'transform 0.25s ease',
//             transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
//             color: isExpanded ? '#fff' : '#94a3b8',
//           }}
//         >
//           <KeyboardArrowDown />
//         </Box>
//       </Box>

//       {/* ── Expanded Content ── */}
//       <Collapse in={isExpanded} timeout={250} unmountOnExit>
//         <Box
//           sx={{
//             border: '1.5px solid #330066',
//             borderTop: 'none',
//             borderRadius: '0 0 14px 14px',
//             overflow: 'hidden',
//             bgcolor: '#f8faff',
//           }}
//         >
//           {/* Mini summary bar */}
//           <Box
//             sx={{
//               display: 'flex',
//               borderBottom: '1px solid #e2e8f0',
//               bgcolor: '#fff',
//             }}
//           >
//             {[
//               { label: 'Strength', value: strength, color: '#330066', bg: '#e8f0fe' },
//               { label: 'Present', value: present, color: '#16a34a', bg: '#dcfce7' },
//               { label: 'Absent', value: absent, color: '#dc2626', bg: '#fee2e2' },
//             ].map((s) => (
//               <Box
//                 key={s.label}
//                 sx={{
//                   flex: 1,
//                   textAlign: 'center',
//                   py: 1.5,
//                   borderRight: '1px solid #f1f5f9',
//                   '&:last-child': { borderRight: 'none' },
//                 }}
//               >
//                 <Typography sx={{ fontSize: '0.65rem', color: '#64748b', mb: 0.3 }}>
//                   {s.label}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: '1.05rem',
//                     fontWeight: 800,
//                     color: s.color,
//                   }}
//                 >
//                   {s.value}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>

//           {/* Employee mini-table */}
//           <Box sx={{ px: 1.5, pt: 1, pb: 0.5 }}>
//             {/* Table header */}
//             <Box
//               sx={{
//                 display: 'grid',
//                 gridTemplateColumns: '1fr 1.4fr 1.4fr 0.5fr',
//                 gap: 0.5,
//                 px: 1,
//                 py: 0.75,
//                 bgcolor: '#e8f0fe',
//                 borderRadius: '8px',
//                 mb: 0.5,
//               }}
//             >
//               {['Svc No', 'Name','Designation' ,'IN'].map((h) => (
//                 <Typography key={h} sx={{ fontSize: '0.62rem', fontWeight: 700, color: '#330066' }}>
//                   {h}
//                 </Typography>
//               ))}
//             </Box>

//             {/* Table rows — show all */}
//             {employees.map((emp, idx) => {
//               const present = isPresent(emp);
//               return (
//                 <Box
//                   key={emp.sno || idx}
//                   onClick={(e) => { e.stopPropagation(); onEmployeeClick && onEmployeeClick(emp); }}
//                   sx={{
//                     display: 'grid',
//                     gridTemplateColumns: '1fr 1.4fr 1.4fr 0.5fr',
//                     gap: 0.5,
//                     px: 1,
//                     py: 0.9,
//                     bgcolor: idx % 2 === 0 ? '#fff' : '#f8faff',
//                     borderRadius: '6px',
//                     mb: 0.25,
//                     alignItems: 'center',
//                     cursor: 'pointer',
//                     transition: 'background 0.15s ease',
//                     '&:hover': { bgcolor: 'rgba(0,74,173,0.06)' },
//                   }}
//                 >
//                   <Typography sx={{ fontSize: '0.68rem', color: '#475569' }}>
//                     {emp.sno || '-'}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       fontSize: '0.72rem',
//                       fontWeight: 600,
//                       color: '#1e293b',
//                       lineHeight: 1.2,
//                       wordBreak: 'break-word',
//                     }}
//                   >
//                     {emp.repname || '-'}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       fontSize: '0.6rem',
//                       fontWeight: 600,
//                       color: '#1e293b',
//                       lineHeight: 1.2,
//                       wordBreak: 'break-word',
//                     }}
//                   >
//                     {emp.des || '-'}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       fontSize: '0.68rem',
//                       fontWeight: present ? 700 : 400,
//                       color: present ? '#16a34a' : '#f30a0a',
//                     }}
//                   >
//                     {present ? emp.inn : 'NR'}
//                   </Typography>
                  
//                 </Box>
//               );
//             })}
//           </Box>

//           {/* View all button */}
//           <Box sx={{ px: 2, py: 1.5 }}>
//             <Button
//               fullWidth
//               variant="contained"
//               size="small"
//               startIcon={<Visibility />}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onViewAll({ location, employees, strength, present, absent, rate });
//               }}
//               sx={{
//                 bgcolor: '#330066',
//                 borderRadius: '10px',
//                 textTransform: 'none',
//                 fontWeight: 600,
//                 fontSize: '0.8rem',
//                 py: 1,
//                 '&:hover': { bgcolor: '#002d7a' },
//               }}
//             >
//               Full Details
//             </Button>
//           </Box>
//         </Box>
//       </Collapse>
//     </Box>
//   );
// });

// // ─── Detail Drawer ───────────────────────────────────────────────────────────
// const DetailDrawer = ({ open, onClose, data, onEmployeeClick }) => {
//   if (!data) return null;
//   const { location, employees, strength, present, absent, rate } = data;
//   const rateColor = rate >= 80 ? '#16a34a' : rate >= 60 ? '#d97706' : '#dc2626';

//   return (
//     <SwipeableDrawer
//       anchor="bottom"
//       open={open}
//       onClose={onClose}
//       onOpen={() => {}}
//       disableSwipeToOpen
//       sx={{
//         '& .MuiDrawer-paper': {
//           borderTopLeftRadius: '24px',
//           borderTopRightRadius: '24px',
//           maxHeight: '88vh',
//           display: 'flex',
//           flexDirection: 'column',
//           overflow: 'hidden',
//         },
//       }}
//     >
//       {/* Pull indicator */}
//       <Box sx={{ pt: 1.5, pb: 0.5, display: 'flex', justifyContent: 'center' }}>
//         <Box sx={{ width: 40, height: 4, borderRadius: 2, bgcolor: '#cbd5e1' }} />
//       </Box>

//       {/* Header */}
//       <Box
//         sx={{
//           px: 2.5,
//           py: 2,
//           bgcolor: '#330066',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           flexShrink: 0,
//         }}
//       >
//         <Box>
//           <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '1rem', lineHeight: 1.2 }}>
//             {location}
//           </Typography>
//           <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem', mt: 0.3 }}>
//             {strength} employees
//           </Typography>
//         </Box>
//         <IconButton onClick={onClose} sx={{ color: '#fff' }}>
//           <Close />
//         </IconButton>
//       </Box>

//       {/* Stats */}
//       <Box sx={{ display: 'flex', flexShrink: 0, borderBottom: '1px solid #f1f5f9' }}>
//         {[
//           { label: 'Total', value: strength, color: '#330066' },
//           { label: 'Present', value: present, color: '#16a34a' },
//           { label: 'Absent', value: absent, color: '#dc2626' },
//           { label: 'Rate', value: `${rate}%`, color: rateColor },
//         ].map((s) => (
//           <Box
//             key={s.label}
//             sx={{
//               flex: 1,
//               textAlign: 'center',
//               py: 1.5,
//               borderRight: '1px solid #f1f5f9',
//               '&:last-child': { borderRight: 'none' },
//             }}
//           >
//             <Typography sx={{ fontSize: '0.63rem', color: '#64748b' }}>{s.label}</Typography>
//             <Typography sx={{ fontSize: '1.1rem', fontWeight: 800, color: s.color }}>
//               {s.value}
//             </Typography>
//           </Box>
//         ))}
//       </Box>

//       {/* Scrollable employee list */}
//       <Box sx={{ overflowY: 'auto', flex: 1, px: 2, py: 1.5 }}>
//         {/* Column headers */}
//         <Box
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: '0.8fr 1.4fr 1fr 0.8fr 0.6fr',
//             gap: 0.5,
//             px: 1,
//             py: 0.8,
//             bgcolor: '#e8f0fe',
//             borderRadius: '8px',
//             mb: 1,
//             position: 'sticky',
//             top: 0,
//             zIndex: 1,
//           }}
//         >
//           {['Svc No', 'Name', 'Designation', 'IN Time', 'Status'].map((h) => (
//             <Typography key={h} sx={{ fontSize: '0.6rem', fontWeight: 700, color: '#330066' }}>
//               {h}
//             </Typography>
//           ))}
//         </Box>

//         {employees.map((emp, idx) => {
//           const present = isPresent(emp);
//           return (
//             <Box
//               key={emp.sno || idx}
//               onClick={() => onEmployeeClick && onEmployeeClick(emp)}
//               sx={{
//                 display: 'grid',
//                 gridTemplateColumns: '0.8fr 1.4fr 1fr 0.8fr 0.6fr',
//                 gap: 0.5,
//                 px: 1,
//                 py: 1,
//                 bgcolor: idx % 2 === 0 ? '#fff' : '#f8faff',
//                 borderRadius: '8px',
//                 mb: 0.5,
//                 alignItems: 'center',
//                 border: '1px solid #f1f5f9',
//                 cursor: 'pointer',
//                 transition: 'background 0.15s ease',
//                 '&:hover': { bgcolor: 'rgba(0,74,173,0.06)' },
//               }}
//             >
//               <Typography sx={{ fontSize: '0.65rem', color: '#475569' }}>
//                 {emp.sno || '-'}
//               </Typography>
//               <Box>
//                 <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#1e293b', lineHeight: 1.2 }}>
//                   {emp.repname || '-'}
//                 </Typography>
//                 <Typography sx={{ fontSize: '0.6rem', color: '#94a3b8' }}>
//                   {emp.cno ? `Clk: ${emp.cno}` : ''}
//                 </Typography>
//               </Box>
//               <Typography sx={{ fontSize: '0.62rem', color: '#64748b', lineHeight: 1.2 }}>
//                 {emp.des || '-'}
//               </Typography>
//               <Box>
//                 <Typography
//                   sx={{
//                     fontSize: '0.7rem',
//                     fontWeight: present ? 700 : 400,
//                     color: present ? '#16a34a' : '#94a3b8',
//                   }}
//                 >
//                   {present ? emp.inn : 'NR'}
//                 </Typography>
//                 {emp.pout && (
//                   <Typography sx={{ fontSize: '0.58rem', color: '#94a3b8' }}>
//                     OUT: {emp.pout}
//                   </Typography>
//                 )}
//               </Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 {present ? (
//                   <CheckCircle sx={{ fontSize: 16, color: '#16a34a' }} />
//                 ) : (
//                   <Cancel sx={{ fontSize: 16, color: '#dc2626' }} />
//                 )}
//               </Box>
//             </Box>
//           );
//         })}
//       </Box>
//     </SwipeableDrawer>
//   );
// };

// // ─── Desktop Table View ──────────────────────────────────────────────────────
// const DesktopTableView = ({ locationGroups, expandedRow, onExpand, onViewDetails, onEmployeeClick }) => (
//   <TableContainer>
//     <Table>
//       <TableHead sx={{ bgcolor: '#330066' }}>
//         <TableRow>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '35%' }}>Location</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Strength</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Present</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Attendance</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Actions</TableCell>
//         </TableRow>
//       </TableHead>
//       <TableBody>
//         {Object.entries(locationGroups).map(([location, employees]) => {
//           const strength = employees.length;
//           const present = employees.filter(isPresent).length;
//           const absent = strength - present;
//           const rate = strength > 0 ? Math.round((present / strength) * 100) : 0;
//           const rateColor = rate >= 80 ? '#16a34a' : rate >= 60 ? '#d97706' : '#dc2626';
//           const expanded = expandedRow === location;

//           return (
//             <React.Fragment key={location}>
//               <TableRow hover sx={{ '&:hover': { bgcolor: 'rgba(0,74,173,0.04)' } }}>
//                 <TableCell>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Business sx={{ color: '#330066' }} />
//                     <Typography fontWeight={500}>{location}</Typography>
//                   </Box>
//                 </TableCell>
//                 <TableCell align="center">
//                   <Chip label={strength} size="small" sx={{ bgcolor: '#e8f0fe', color: '#330066', fontWeight: 'bold' }} />
//                 </TableCell>
//                 <TableCell align="center">
//                   <Chip label={present} size="small" sx={{ bgcolor: '#dcfce7', color: '#16a34a', fontWeight: 'bold' }} />
//                 </TableCell>
//                 <TableCell align="center">
//                   <Chip
//                     label={`${rate}%`}
//                     size="small"
//                     sx={{ bgcolor: `${rateColor}18`, color: rateColor, fontWeight: 'bold' }}
//                   />
//                 </TableCell>
//                 <TableCell align="center">
//                   <IconButton size="small" onClick={() => onExpand(location)} sx={{ color: '#330066' }}>
//                     {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
//                   </IconButton>
//                   <Button
//                     size="small"
//                     variant="outlined"
//                     startIcon={<Visibility />}
//                     onClick={() => onViewDetails({ location, employees, strength, present, absent, rate })}
//                     sx={{ ml: 1, borderColor: '#330066', color: '#330066', textTransform: 'none' }}
//                   >
//                     View
//                   </Button>
//                 </TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell colSpan={5} sx={{ py: 0 }}>
//                   <Collapse in={expanded} timeout="auto" unmountOnExit>
//                     <Box sx={{ m: 2, bgcolor: '#f8faff', borderRadius: '12px', p: 2 }}>
//                       <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: '#330066' }}>
//                         Employee List — {location}
//                       </Typography>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow sx={{ bgcolor: '#e8f0fe' }}>
//                             {['Service No', 'Name', 'Designation', 'Clock No', 'IN Time', 'Prev. OUT', 'Status'].map(h => (
//                               <TableCell key={h}><b>{h}</b></TableCell>
//                             ))}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {employees.map((emp, idx) => {
//                             const p = isPresent(emp);
//                             return (
//                               <TableRow key={emp.sno || idx} onClick={() => onEmployeeClick && onEmployeeClick(emp)} sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'rgba(0,74,173,0.06)' } }}>
//                                 <TableCell>{emp.sno || '-'}</TableCell>
//                                 <TableCell>{emp.repname || '-'}</TableCell>
//                                 <TableCell>{emp.des || '-'}</TableCell>
//                                 <TableCell>{emp.cno || '-'}</TableCell>
//                                 <TableCell>
//                                   <Chip
//                                     label={p ? emp.inn : 'NR'}
//                                     size="small"
//                                     sx={{ bgcolor: p ? '#dcfce7' : '#fee2e2', color: p ? '#16a34a' : '#dc2626', fontSize: '0.7rem' }}
//                                   />
//                                 </TableCell>
//                                 <TableCell>{emp.pout || '-'}</TableCell>
//                                 <TableCell>
//                                   <Chip
//                                     label={p ? 'Present' : 'Absent'}
//                                     size="small"
//                                     icon={p ? <CheckCircle sx={{ fontSize: '12px !important' }} /> : <Cancel sx={{ fontSize: '12px !important' }} />}
//                                     sx={{ bgcolor: p ? '#dcfce7' : '#fee2e2', color: p ? '#16a34a' : '#dc2626', fontSize: '0.7rem' }}
//                                   />
//                                 </TableCell>
//                               </TableRow>
//                             );
//                           })}
//                         </TableBody>
//                       </Table>
//                     </Box>
//                   </Collapse>
//                 </TableCell>
//               </TableRow>
//             </React.Fragment>
//           );
//         })}
//       </TableBody>
//     </Table>
//   </TableContainer>
// );

// // ─── Main Export ─────────────────────────────────────────────────────────────
// export const DGESatt = ({ data = [], loading = false }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const [expandedRow, setExpandedRow] = useState(null);
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [showScrollTop, setShowScrollTop] = useState(false);
//   const [empDetailOpen, setEmpDetailOpen] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const scrollRef = useRef(null); 
//   const handleToggle = useCallback((location) => {
//     setExpandedRow(prev => (prev === location ? null : location)); 
//   }, []);

//   const handleViewDetails = useCallback((locationData) => {
//     setSelectedLocation(locationData);
//     setDrawerOpen(true);
//   }, []);

//   const handleScroll = useCallback((e) => {
//     setShowScrollTop(e.currentTarget.scrollTop > 200);
//   }, []);

//   const handleEmployeeClick = useCallback((emp) => {
//     setSelectedEmployee(emp);
//     setEmpDetailOpen(true);
//   }, []);

//   const scrollToTop = useCallback(() => {
//     scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);

//   // ── Loading / empty ──
//   if (loading) {
//     return (
//       <Paper sx={{ p: 3, borderRadius: '20px' }}>
//         <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
//           <Typography>Loading CDPLC data...</Typography>
//         </Box>
//       </Paper>
//     );
//   }

//   if (!data || data.length === 0) {
//     return (
//       <Paper sx={{ p: 3, borderRadius: '20px' }}>
//         <Typography color="error" align="center">
//           No CDPLC data available.
//         </Typography>
//       </Paper>
//     );
//   }

//   // ── Group by location ──
//   const locationGroups = {};
//   data.forEach(item => {
//     const loc = item.loc?.trim() || 'Unknown';
//     if (!locationGroups[loc]) locationGroups[loc] = [];
//     locationGroups[loc].push(item);
//   });

//   const totalLocations = Object.keys(locationGroups).length;
//   const totalEmployees = data.length;
//   const totalPresent = data.filter(isPresent).length;

//   return (
//     <>
//       <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: '20px', boxShadow: '0 4px 24px rgba(0,74,173,0.06)' }}>
//         <Typography
//           variant="h6"
//           sx={{ mb: 2.5, fontWeight: 700, color: '#330066', fontSize: { xs: '1rem', sm: '1.2rem' } }}
//         >
//           Based on Designation and Location
//         </Typography>

//         {/* ── Mobile ── */}
//         {isMobile ? (
//           <Box
//             ref={scrollRef}
//             onScroll={handleScroll}
//             sx={{
//               maxHeight: 'calc(100vh - 180px)',
//               overflowY: 'auto',
//               overflowX: 'hidden',
//               pr: 0.5,
//               '&::-webkit-scrollbar': { width: 4 },
//               '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
//               '&::-webkit-scrollbar-thumb': { bgcolor: '#cbd5e1', borderRadius: 4 },
//             }}
//           >
//             {Object.entries(locationGroups).map(([location, employees]) => (
//               <MobileLocationPanel
//                 key={location}
//                 location={location}
//                 employees={employees}
//                 isExpanded={expandedRow === location}
//                 onToggle={handleToggle}
//                 onViewAll={handleViewDetails}
//                 onEmployeeClick={handleEmployeeClick}
//               />
//             ))}

//             {/* Spacer so last card isn't hidden by FAB */}
//             <Box sx={{ height: 80 }} />
//           </Box>
//         ) : (
//           /* ── Desktop ── */
//           <DesktopTableView
//             locationGroups={locationGroups}
//             expandedRow={expandedRow}
//             onExpand={handleToggle}
//             onViewDetails={handleViewDetails}
//             onEmployeeClick={handleEmployeeClick}
//           />
//         )}
        
//       </Paper>

//       {/* Detail Drawer */}
//       <DetailDrawer
//         open={drawerOpen}
//         onClose={() => { setDrawerOpen(false); setTimeout(() => setSelectedLocation(null), 300); }}
//         data={selectedLocation}
//         onEmployeeClick={handleEmployeeClick}
//       />

//       {/* Employee Detail Drawer */}
//       <EmployeeDetailDrawer
//         open={empDetailOpen}
//         onClose={() => { setEmpDetailOpen(false); setTimeout(() => setSelectedEmployee(null), 300); }}
//         employee={selectedEmployee}
//       />
//     </>
//   );
// };

//-------------------------------------------------------------------My Design---------------------------------------------------------------------------------
// import axios from 'axios';
// import { useNavigate } from "react-router-dom";
// import React, { useEffect, useState, useCallback, useRef } from 'react';
// import { useLocation } from "react-router-dom";
// import EmployeeDetailDrawer from './EmployeeDetailDrawer';
// import AttendanceService from '../../service/AttendanceService';
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   Collapse,
//   IconButton,
//   Button,
//   Avatar,
//   SwipeableDrawer,
//   CircularProgress,
//   useTheme,
//   useMediaQuery,
//   Breadcrumbs,
//   Link,
// } from '@mui/material';
// import {
//   KeyboardArrowDown,
//   KeyboardArrowUp,
//   Close,
//   Visibility,
//   People,
//   CheckCircle,
//   Cancel,
//   LocationOn,
//   AccountTree,
//   NavigateNext,
//   Business,
// } from '@mui/icons-material';

// // ─── Helpers ─────────────────────────────────────────────────────────────────
// const todayISO = () => new Date().toISOString().split('T')[0];

// const isPresent = (emp) =>
//   emp.InTime && emp.InTime !== '' && emp.InTime !== null;

// // ─── Loading Placeholder ─────────────────────────────────────────────────────
// const LoadingBox = ({ message = 'Loading…' }) => (
//   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6, gap: 2 }}>
//     <CircularProgress sx={{ color: '#330066' }} size={32} />
//     <Typography sx={{ color: '#64748b', fontSize: '0.85rem' }}>{message}</Typography>
//   </Box>
// );

// // ─── Empty Placeholder ───────────────────────────────────────────────────────
// const EmptyBox = ({ message }) => (
//   <Box sx={{ textAlign: 'center', py: 6 }}>
//     <Typography sx={{ color: '#94a3b8', fontSize: '0.85rem' }}>{message}</Typography>
//   </Box>
// );

// // ─── Step 1: Division List ────────────────────────────────────────────────────
// const DivisionList = ({ divisions, onSelect }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   return (
//     <Box>
//       <Typography sx={{ mb: 2, fontSize: '0.78rem', color: '#64748b' }}>
//         Select a division to view its locations
//       </Typography>
//       <Box
//         sx={{
//           display: 'grid',
//           gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(240px, 1fr))',
//           gap: 1.5,
//         }}
//       >
//         {divisions.map((div) => (
//           <Box
//             key={div.DivisionCode}
//             onClick={() => onSelect(div)}
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 1.5,
//               p: 2,
//               bgcolor: '#fff',
//               border: '1.5px solid #e2e8f0',
//               borderRadius: '14px',
//               cursor: 'pointer',
//               transition: 'all 0.2s ease',
//               '&:hover': {
//                 borderColor: '#330066',
//                 bgcolor: '#f0f5ff',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 4px 16px rgba(0,74,173,0.1)',
//               },
//             }}
//           >
//             <Avatar sx={{ width: 38, height: 38, bgcolor: '#e8f0fe' }}>
//               <AccountTree sx={{ fontSize: 18, color: '#330066' }} />
//             </Avatar>
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography sx={{ fontWeight: 700, fontSize: '0.88rem', color: '#1e293b' }}>
//                 {div.DivisionCode}
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: '0.72rem',
//                   color: '#64748b',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                   whiteSpace: 'nowrap',
//                 }}
//               >
//                 {div.DivisionName}
//               </Typography>
//             </Box>
//             <KeyboardArrowDown sx={{ color: '#94a3b8', fontSize: 18 }} />
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// // ─── Mobile Location Panel ────────────────────────────────────────────────────
// const MobileLocationPanel = React.memo(({
//   location,
//   employees,
//   isExpanded,
//   onToggle,
//   onViewAll,
//   onEmployeeClick,
//   panelRef,
// }) => {
//   const strength = location.Emp_Total ?? employees.length;
//   const present = employees.length > 0 ? employees.filter(isPresent).length : location.Emp_real ?? 0;
//   const absent = strength - present;
//   const rate = location.Percentage != null
//     ? Math.round(location.Percentage)
//     : (strength > 0 ? Math.round((present / strength) * 100) : 0);
//   const rateColor = rate >= 80 ? '#16a34a' : rate >= 60 ? '#d97706' : '#dc2626';

//   return (
//     <Box ref={panelRef} sx={{ mb: 1.5 }}>
//       <Box
//         onClick={() => onToggle(location.LocationCode)}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: 1.5,
//           px: 2,
//           py: 1.5,
//           bgcolor: isExpanded ? '#330066' : '#fff',
//           border: '1.5px solid',
//           borderColor: isExpanded ? '#330066' : '#e2e8f0',
//           borderRadius: isExpanded ? '14px 14px 0 0' : '14px',
//           cursor: 'pointer',
//           transition: 'all 0.25s ease',
//           userSelect: 'none',
//         }}
//       >
//         <Avatar sx={{ width: 36, height: 36, bgcolor: isExpanded ? 'rgba(255,255,255,0.2)' : '#e8f0fe', flexShrink: 0 }}>
//           <LocationOn sx={{ fontSize: 18, color: isExpanded ? '#fff' : '#330066' }} />
//         </Avatar>
//         <Typography sx={{ flex: 1, fontWeight: 700, fontSize: '0.88rem', color: isExpanded ? '#fff' : '#1e293b', lineHeight: 1.3 }}>
//           {location.LocationCode}
//         </Typography>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0 }}>
//           <Chip
//             icon={<People sx={{ fontSize: '13px !important', color: isExpanded ? '#fff !important' : '#330066 !important' }} />}
//             label={`${present}/${strength}`}
//             size="small"
//             sx={{ height: 24, fontSize: '0.72rem', fontWeight: 700, bgcolor: isExpanded ? 'rgba(255,255,255,0.18)' : '#e8f0fe', color: isExpanded ? '#fff' : '#330066', '& .MuiChip-icon': { ml: '4px' } }}
//           />
//           <Chip
//             label={`${rate}%`}
//             size="small"
//             sx={{ height: 24, fontSize: '0.72rem', fontWeight: 700, bgcolor: isExpanded ? 'rgba(255,255,255,0.18)' : `${rateColor}18`, color: isExpanded ? '#fff' : rateColor }}
//           />
//         </Box>
//         <Box sx={{ flexShrink: 0, transition: 'transform 0.25s ease', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', color: isExpanded ? '#fff' : '#94a3b8' }}>
//           <KeyboardArrowDown />
//         </Box>
//       </Box>

//       <Collapse in={isExpanded} timeout={250} unmountOnExit>
//         <Box sx={{ border: '1.5px solid #330066', borderTop: 'none', borderRadius: '0 0 14px 14px', overflow: 'hidden', bgcolor: '#f8faff' }}>
//           <Box sx={{ display: 'flex', borderBottom: '1px solid #e2e8f0', bgcolor: '#fff' }}>
//             {[
//               { label: 'Strength', value: strength, color: '#330066' },
//               { label: 'Present', value: present, color: '#16a34a' },
//               { label: 'Absent', value: absent, color: '#dc2626' },
//             ].map((s) => (
//               <Box key={s.label} sx={{ flex: 1, textAlign: 'center', py: 1.5, borderRight: '1px solid #f1f5f9', '&:last-child': { borderRight: 'none' } }}>
//                 <Typography sx={{ fontSize: '0.65rem', color: '#64748b', mb: 0.3 }}>{s.label}</Typography>
//                 <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: s.color }}>{s.value}</Typography>
//               </Box>
//             ))}
//           </Box>

//           <Box sx={{ px: 1.5, pt: 1, pb: 0.5 }}>
//             <Box sx={{ display: 'grid', gridTemplateColumns: '0.8fr 1.6fr 1.2fr 0.7fr 0.5fr', gap: 0.5, px: 1, py: 0.75, bgcolor: '#e8f0fe', borderRadius: '8px', mb: 0.5 }}>
//               {['Service No', 'Name', 'Designation', 'IN', ''].map((h) => (
//                 <Typography key={h} sx={{ fontSize: '0.62rem', fontWeight: 700, color: '#330066' }}>{h}</Typography>
//               ))}
//             </Box>
//             {employees.map((emp, idx) => {
//               const p = isPresent(emp);
//               return (
//                 <Box
//                   key={emp.ServiceNo || idx}
//                   onClick={(e) => { e.stopPropagation(); onEmployeeClick({ sno: emp.ServiceNo, repname: emp.EmployeeName, des: emp.Designation, inn: emp.InTime, pout: emp.OutTime }); }}
//                   sx={{ display: 'grid', gridTemplateColumns: '0.8fr 1.6fr 1.2fr 0.7fr 0.5fr', gap: 0.5, px: 1, py: 0.9, bgcolor: idx % 2 === 0 ? '#fff' : '#f8faff', borderRadius: '6px', mb: 0.25, alignItems: 'center', cursor: 'pointer', transition: 'background 0.15s ease', '&:hover': { bgcolor: 'rgba(0,74,173,0.06)' } }}
//                 >
//                   <Typography sx={{ fontSize: '0.65rem', color: '#475569' }}>{emp.ServiceNo || '-'}</Typography>
//                   <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#1e293b', lineHeight: 1.2, wordBreak: 'break-word' }}>{emp.EmployeeName || '-'}</Typography>
//                   <Typography sx={{ fontSize: '0.6rem', color: '#64748b', lineHeight: 1.2 }}>{emp.Designation || '-'}</Typography>
//                   <Typography sx={{ fontSize: '0.68rem', fontWeight: p ? 700 : 400, color: p ? '#16a34a' : '#dc2626' }}>{p ? emp.InTime : 'NR'}</Typography>
//                   <Box sx={{ display: 'flex', justifyContent: 'center' }}>
//                     {p ? <CheckCircle sx={{ fontSize: 15, color: '#16a34a' }} /> : <Cancel sx={{ fontSize: 15, color: '#dc2626' }} />}
//                   </Box>
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       </Collapse>
//     </Box>
//   );
// });

// // ─── Desktop Location Table ───────────────────────────────────────────────────
// const DesktopLocationTable = ({ locations, employees, expandedRow, onExpand, onViewDetails, onEmployeeClick, rowRefs }) => (
//   <TableContainer>
//     <Table>
//       <TableHead sx={{ bgcolor: '#330066' }}>
//         <TableRow>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold', width: '35%' }}>Location</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Strength</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Present</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Attendance</TableCell>
//           <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Actions</TableCell>
//         </TableRow>
//       </TableHead>
//       <TableBody>
//         {locations.map((loc) => {
//           const locEmployees = employees[loc.LocationCode] || [];
//           const strength = loc.Emp_Total ?? locEmployees.length;
//           const present = locEmployees.length > 0 ? locEmployees.filter(isPresent).length : loc.Emp_real ?? 0;
//           const absent = strength - present;
//           const rate = loc.Percentage != null ? Math.round(loc.Percentage) : (strength > 0 ? Math.round((present / strength) * 100) : 0);
//           const rateColor = rate >= 80 ? '#16a34a' : rate >= 60 ? '#d97706' : '#dc2626';
//           const expanded = expandedRow === loc.LocationCode;

//           return (
//             <React.Fragment key={loc.LocationCode}>
//               <TableRow
//                 ref={(el) => { rowRefs.current[loc.LocationCode] = el; }}
//                 hover
//                 sx={{ '&:hover': { bgcolor: 'rgba(0,74,173,0.04)' } }}
//               >
//                 <TableCell>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Business sx={{ color: '#330066' }} />
//                     <Typography fontWeight={500}>{loc.LocationCode}</Typography>
//                   </Box>
//                 </TableCell>
//                 <TableCell align="center">
//                   <Chip label={strength} size="small" sx={{ bgcolor: '#e8f0fe', color: '#330066', fontWeight: 'bold' }} />
//                 </TableCell>
//                 <TableCell align="center">
//                   <Chip label={present} size="small" sx={{ bgcolor: '#dcfce7', color: '#16a34a', fontWeight: 'bold' }} />
//                 </TableCell>
//                 <TableCell align="center">
//                   <Chip label={`${rate}%`} size="small" sx={{ bgcolor: `${rateColor}18`, color: rateColor, fontWeight: 'bold' }} />
//                 </TableCell>
//                 <TableCell align="center">
//                   <IconButton size="small" onClick={() => onExpand(loc.LocationCode)} sx={{ color: '#330066' }}>
//                     {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
//                   </IconButton>
//                   <Button size="small" variant="outlined" startIcon={<Visibility />} onClick={() => onViewDetails({ location: loc, employees: locEmployees, strength, present, absent, rate })} sx={{ ml: 1, borderColor: '#330066', color: '#330066', textTransform: 'none' }}>
//                     View
//                   </Button>
//                 </TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell colSpan={5} sx={{ py: 0 }}>
//                   <Collapse in={expanded} timeout="auto" unmountOnExit>
//                     <Box sx={{ m: 2, bgcolor: '#f8faff', borderRadius: '12px', p: 2 }}>
//                       <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold', color: '#330066' }}>
//                         Employee List — {loc.LocationCode}
//                       </Typography>
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow sx={{ bgcolor: '#e8f0fe' }}>
//                             {['Service No', 'Employee Name', 'Designation', 'IN Time', 'OUT Time', 'Status'].map((h) => (
//                               <TableCell key={h}><b>{h}</b></TableCell>
//                             ))}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {locEmployees.map((emp, idx) => {
//                             const p = isPresent(emp);
//                             return (
//                               <TableRow key={emp.ServiceNo || idx} onClick={() => onEmployeeClick({ sno: emp.ServiceNo, repname: emp.EmployeeName, des: emp.Designation, inn: emp.InTime, pout: emp.OutTime })} sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'rgba(0,74,173,0.06)' } }}>
//                                 <TableCell sx={{ fontSize: '0.8rem' }}>{emp.ServiceNo || '-'}</TableCell>
//                                 <TableCell sx={{ fontSize: '0.82rem', fontWeight: 600 }}>{emp.EmployeeName || '-'}</TableCell>
//                                 <TableCell sx={{ fontSize: '0.78rem', color: '#64748b' }}>{emp.Designation || '-'}</TableCell>
//                                 <TableCell>
//                                   <Chip label={p ? emp.InTime : 'NR'} size="small" sx={{ bgcolor: p ? '#dcfce7' : '#fee2e2', color: p ? '#16a34a' : '#dc2626', fontWeight: 700, fontSize: '0.7rem' }} />
//                                 </TableCell>
//                                 <TableCell sx={{ fontSize: '0.78rem', color: '#64748b' }}>{emp.OutTime || '-'}</TableCell>
//                                 <TableCell>
//                                   <Chip label={p ? 'Present' : 'Absent'} size="small" icon={p ? <CheckCircle sx={{ fontSize: '12px !important' }} /> : <Cancel sx={{ fontSize: '12px !important' }} />} sx={{ bgcolor: p ? '#dcfce7' : '#fee2e2', color: p ? '#16a34a' : '#dc2626', fontSize: '0.7rem' }} />
//                                 </TableCell>
//                               </TableRow>
//                             );
//                           })}
//                         </TableBody>
//                       </Table>
//                     </Box>
//                   </Collapse>
//                 </TableCell>
//               </TableRow>
//             </React.Fragment>
//           );
//         })}
//       </TableBody>
//     </Table>
//   </TableContainer>
// );

// // ─── Detail Drawer ────────────────────────────────────────────────────────────
// const DetailDrawer = ({ open, onClose, data, onEmployeeClick }) => {
//   if (!data) return null;
//   const { location, employees, strength, present, absent, rate } = data;
//   const rateColor = rate >= 80 ? '#16a34a' : rate >= 60 ? '#d97706' : '#dc2626';

//   return (
//     <SwipeableDrawer anchor="bottom" open={open} onClose={onClose} onOpen={() => {}} disableSwipeToOpen
//       sx={{ '& .MuiDrawer-paper': { borderTopLeftRadius: '24px', borderTopRightRadius: '24px', maxHeight: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' } }}
//     >
//       <Box sx={{ pt: 1.5, pb: 0.5, display: 'flex', justifyContent: 'center' }}>
//         <Box sx={{ width: 40, height: 4, borderRadius: 2, bgcolor: '#cbd5e1' }} />
//       </Box>
//       <Box sx={{ px: 2.5, py: 2, bgcolor: '#330066', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
//         <Box>
//           <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '1rem', lineHeight: 1.2 }}>{location?.LocationCode}</Typography>
//           <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem', mt: 0.3 }}>{strength} employees</Typography>
//         </Box>
//         <IconButton onClick={onClose} sx={{ color: '#fff' }}><Close /></IconButton>
//       </Box>
//       <Box sx={{ display: 'flex', flexShrink: 0, borderBottom: '1px solid #f1f5f9' }}>
//         {[
//           { label: 'Total', value: strength, color: '#330066' },
//           { label: 'Present', value: present, color: '#16a34a' },
//           { label: 'Absent', value: absent, color: '#dc2626' },
//           { label: 'Rate', value: `${rate}%`, color: rateColor },
//         ].map((s) => (
//           <Box key={s.label} sx={{ flex: 1, textAlign: 'center', py: 1.5, borderRight: '1px solid #f1f5f9', '&:last-child': { borderRight: 'none' } }}>
//             <Typography sx={{ fontSize: '0.63rem', color: '#64748b' }}>{s.label}</Typography>
//             <Typography sx={{ fontSize: '1.1rem', fontWeight: 800, color: s.color }}>{s.value}</Typography>
//           </Box>
//         ))}
//       </Box>
//       <Box sx={{ overflowY: 'auto', flex: 1, px: 2, py: 1.5 }}>
//         <Box sx={{ display: 'grid', gridTemplateColumns: '0.8fr 1.6fr 1.2fr 0.7fr 0.5fr', gap: 0.5, px: 1, py: 0.8, bgcolor: '#e8f0fe', borderRadius: '8px', mb: 1, position: 'sticky', top: 0, zIndex: 1 }}>
//           {['Service No', 'Name', 'Designation', 'IN Time', 'Status'].map((h) => (
//             <Typography key={h} sx={{ fontSize: '0.6rem', fontWeight: 700, color: '#330066' }}>{h}</Typography>
//           ))}
//         </Box>
//         {employees.map((emp, idx) => {
//           const p = isPresent(emp);
//           return (
//             <Box key={emp.ServiceNo || idx} onClick={() => onEmployeeClick({ sno: emp.ServiceNo, repname: emp.EmployeeName, des: emp.Designation, inn: emp.InTime, pout: emp.OutTime })}
//               sx={{ display: 'grid', gridTemplateColumns: '0.8fr 1.6fr 1.2fr 0.7fr 0.5fr', gap: 0.5, px: 1, py: 1, bgcolor: idx % 2 === 0 ? '#fff' : '#f8faff', borderRadius: '8px', mb: 0.5, alignItems: 'center', border: '1px solid #f1f5f9', cursor: 'pointer', transition: 'background 0.15s ease', '&:hover': { bgcolor: 'rgba(0,74,173,0.06)' } }}
//             >
//               <Typography sx={{ fontSize: '0.65rem', color: '#475569' }}>{emp.ServiceNo || '-'}</Typography>
//               <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#1e293b', lineHeight: 1.2 }}>{emp.EmployeeName || '-'}</Typography>
//               <Typography sx={{ fontSize: '0.62rem', color: '#64748b', lineHeight: 1.2 }}>{emp.Designation || '-'}</Typography>
//               <Box>
//                 <Typography sx={{ fontSize: '0.7rem', fontWeight: p ? 700 : 400, color: p ? '#16a34a' : '#94a3b8' }}>{p ? emp.InTime : 'NR'}</Typography>
//                 {emp.OutTime && <Typography sx={{ fontSize: '0.58rem', color: '#94a3b8' }}>OUT: {emp.OutTime}</Typography>}
//               </Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 {p ? <CheckCircle sx={{ fontSize: 16, color: '#16a34a' }} /> : <Cancel sx={{ fontSize: 16, color: '#dc2626' }} />}
//               </Box>
//             </Box>
//           );
//         })}
//       </Box>
//     </SwipeableDrawer>
//   );
// };

// // ─── Main Export ─────────────────────────────────────────────────────────────
// export const DGESatt = ({ data: _ignored, loading: _ignoredLoading }) => {
//   const navigate = useNavigate();
//   const routeLocation = useLocation();

//   // ── Pull everything from route state ──────────────────────────────────────
//   const routeState        = routeLocation?.state ?? {};
//   const stateLocationCode = routeState?.location?.location ?? routeState?.location ?? null;
//   const stateDivisionCode = routeState?.division ?? null;
//   const stateDate         = routeState?.date ?? null;

//   // ── Clear history state on mount so page refresh shows clean dashboard ────
//   useEffect(() => {
//     if (stateDivisionCode) {
//       window.history.replaceState({}, '', window.location.pathname + window.location.search);
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []); // empty deps — runs once on mount only

//   const theme   = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   // ── Component state ───────────────────────────────────────────────────────
//   const [view,             setView]             = useState('divisions');
//   const [divisions,        setDivisions]        = useState([]);
//   const [locations,        setLocations]        = useState([]);
//   const [employeesMap,     setEmployeesMap]     = useState({});
//   const [loadingLocations, setLoadingLocations] = useState({});
//   const [selectedDivision, setSelectedDivision] = useState(null);
//   const [expandedRow,      setExpandedRow]      = useState(null);
//   const [drawerOpen,       setDrawerOpen]       = useState(false);
//   const [drawerData,       setDrawerData]       = useState(null);
//   const [loading,          setLoading]          = useState(false);
//   const [error,            setError]            = useState(null);
//   const [empDetailOpen,    setEmpDetailOpen]    = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   // ── DOM refs for every location row / panel ───────────────────────────────
//   // { [locationCode]: HTMLElement }
//   const rowRefs = useRef({});

//   // ── The location code we want to scroll to right now ─────────────────────
//   // We store it as state so React re-renders can trigger the scroll effect.
//   const [scrollTarget, setScrollTarget] = useState(null);

//   // ── Utility ───────────────────────────────────────────────────────────────
//   const extractArray = (res) => {
//     const d = res?.data;
//     if (Array.isArray(d)) return d;
//     if (d && Array.isArray(d.data))      return d.data;
//     if (d && Array.isArray(d.ResultSet)) return d.ResultSet;
//     return [];
//   };

//   // ── Core scroll function ──────────────────────────────────────────────────
//   // Called once we know the target row is in the DOM and expanded.
//   const doScroll = useCallback((locationCode) => {
//     const el = rowRefs.current[locationCode];
//     if (el) {
//       el.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   }, []);

//   // ── Effect: fire scroll whenever scrollTarget + employeesMap align ────────
//   // This handles both initial load and subsequent chart clicks.
//   useEffect(() => {
//     if (!scrollTarget) return;
//     // Wait until employees have been fetched (or confirmed empty) for the target
//     if (employeesMap[scrollTarget] === undefined) return;

//     // Give the Collapse animation a head-start (250 ms matches Collapse timeout)
//     const timer = setTimeout(() => {
//       doScroll(scrollTarget);
//       setScrollTarget(null); // clear after scrolling
//     }, 300);

//     return () => clearTimeout(timer);
//   }, [scrollTarget, employeesMap, doScroll]);

//   // ── Helper: expand a location AND queue a scroll ──────────────────────────
//   const expandAndScroll = useCallback(async (divisionCode, locationCode, date) => {
//     setExpandedRow(locationCode);
//     setScrollTarget(locationCode);

//     // Only fetch if not already in map
//     if (employeesMap[locationCode] !== undefined) return;

//     setLoadingLocations((prev) => ({ ...prev, [locationCode]: true }));
//     try {
//       const res = await AttendanceService.GetEmployeesAttendance(
//         divisionCode,
//         locationCode,
//         date || todayISO()
//       );
//       setEmployeesMap((prev) => ({ ...prev, [locationCode]: extractArray(res) }));
//     } catch {
//       setEmployeesMap((prev) => ({ ...prev, [locationCode]: [] }));
//     } finally {
//       setLoadingLocations((prev) => ({ ...prev, [locationCode]: false }));
//     }
//   }, [employeesMap]);

//   // ── Fetch divisions on mount ──────────────────────────────────────────────
//   useEffect(() => {
//     let cancelled = false;
//     (async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const res = await AttendanceService.GetAllDivisions();
//         if (!cancelled)
//           setDivisions(
//             extractArray(res).sort((a, b) => a.DivisionCode.localeCompare(b.DivisionCode))
//           );
//       } catch {
//         if (!cancelled) setError('Failed to load divisions. Please try again.');
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     })();
//     return () => { cancelled = true; };
//   }, []);

//   // ── Load locations for a division ─────────────────────────────────────────
//   const loadLocations = useCallback(async (divisionCode, autoExpandCode = null, autoDate = null) => {
//     setLocations([]);
//     setEmployeesMap({});
//     setExpandedRow(null);
//     setScrollTarget(null);
//     rowRefs.current = {};
//     setLoading(true);
//     setError(null);

//     try {
//       const res = await AttendanceService.GetEmpLocationCount(divisionCode);
//       const list = res?.data?.Data ?? res?.data?.ResultSet ?? res?.data ?? [];
//       const locList = list
//         .map((item) => ({
//           LocationCode: item.Emp_location,
//           LocationName: item.Emp_location,
//           Emp_Total:    item.Emp_Total,
//           Emp_real:     Number(item.Emp_real),
//           Percentage:   item.Percentage,
//         }))
//         .sort((a, b) => a.LocationCode.localeCompare(b.LocationCode));

//       setLocations(locList);

//       // If we have a target location, expand + scroll to it
//       if (autoExpandCode) {
//         await expandAndScroll(divisionCode, autoExpandCode, autoDate);
//       }
//     } catch {
//       setError('Failed to load locations.');
//     } finally {
//       setLoading(false);
//     }
//   }, [expandAndScroll]);

//   // ── Select a division manually (DivisionList click) ───────────────────────
//   const handleSelectDivision = useCallback(async (div) => {
//     setSelectedDivision(div);
//     setView('locations');
//     await loadLocations(div.DivisionCode);
//   }, [loadLocations]);

//   // ── Auto-load from route state (initial load OR navigation from chart) ────
//   // Runs whenever stateDivisionCode / stateLocationCode changes.
//   useEffect(() => {
//     if (!stateDivisionCode) return;

//     const div = { DivisionCode: stateDivisionCode };
//     setSelectedDivision(div);
//     setView('locations');

//     loadLocations(stateDivisionCode, stateLocationCode, stateDate);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [stateDivisionCode, stateLocationCode, stateDate]);
//   // Note: we intentionally omit loadLocations from deps to avoid loops;
//   // it is stable because it is wrapped in useCallback with stable deps.

//   // ── Manual expand / collapse ──────────────────────────────────────────────
//   const handleToggleLocation = useCallback(async (locationCode) => {
//     if (expandedRow === locationCode) {
//       setExpandedRow(null);
//       return;
//     }
//     await expandAndScroll(selectedDivision.DivisionCode, locationCode, stateDate);
//   }, [expandedRow, selectedDivision, stateDate, expandAndScroll]);

//   // ── "View" button → detail drawer ─────────────────────────────────────────
//   const handleViewDetails = useCallback(async (locationData) => {
//     const locationCode = locationData.location?.LocationCode;
//     let emps = locationData.employees;

//     if (!emps || emps.length === 0) {
//       if (employeesMap[locationCode] !== undefined) {
//         emps = employeesMap[locationCode];
//       } else {
//         try {
//           const res = await AttendanceService.GetEmployeesAttendance(
//             selectedDivision.DivisionCode, locationCode, todayISO()
//           );
//           const fetched = extractArray(res);
//           setEmployeesMap((prev) => ({ ...prev, [locationCode]: fetched }));
//           emps = fetched;
//         } catch {
//           emps = [];
//         }
//       }
//     }

//     const strength = emps.length;
//     const present  = emps.filter(isPresent).length;
//     const absent   = strength - present;
//     const rate     = strength > 0 ? Math.round((present / strength) * 100) : 0;

//     setDrawerData({ location: locationData.location, employees: emps, strength, present, absent, rate });
//     setDrawerOpen(true);
//   }, [employeesMap, selectedDivision]);

//   const handleEmployeeClick = useCallback((emp) => {
//     setSelectedEmployee(emp);
//     setEmpDetailOpen(true);
//   }, []);

//   const goToDivisions = useCallback(() => {
//     setView('divisions');
//     setSelectedDivision(null);
//     setLocations([]);
//     setEmployeesMap({});
//     setExpandedRow(null);
//     setScrollTarget(null);
//     rowRefs.current = {};
//   }, []);

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: '20px', boxShadow: '0 4px 24px rgba(0,74,173,0.06)' }}>
//         <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 700, color: '#330066', fontSize: { xs: '1rem', sm: '1.2rem' } }}>
//           Based on Designation and Location
//         </Typography>

//         <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 2.5, '& .MuiBreadcrumbs-ol': { flexWrap: 'wrap' } }}>
//           <Link
//             component="button"
//             underline={view === 'divisions' ? 'none' : 'hover'}
//             onClick={view !== 'divisions' ? goToDivisions : undefined}
//             sx={{ fontSize: '0.8rem', fontWeight: view === 'divisions' ? 700 : 400, color: view === 'divisions' ? '#330066' : '#64748b', cursor: view === 'divisions' ? 'default' : 'pointer', bgcolor: 'transparent', border: 'none', p: 0 }}
//           >
//             Divisions
//           </Link>
//           {selectedDivision && (
//             <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#330066' }}>
//               {selectedDivision.DivisionCode}
//             </Typography>
//           )}
//         </Breadcrumbs>

//         {loading ? (
//           <LoadingBox message={view === 'divisions' ? 'Loading divisions…' : 'Loading locations…'} />
//         ) : error ? (
//           <Box sx={{ textAlign: 'center', py: 4 }}>
//             <Typography color="error" sx={{ mb: 1.5, fontSize: '0.85rem' }}>{error}</Typography>
//             <Button variant="outlined" size="small" onClick={goToDivisions} sx={{ textTransform: 'none', borderColor: '#330066', color: '#330066' }}>
//               Retry from Divisions
//             </Button>
//           </Box>
//         ) : view === 'divisions' ? (
//           divisions.length === 0
//             ? <EmptyBox message="No divisions found." />
//             : <DivisionList divisions={divisions} onSelect={handleSelectDivision} />
//         ) : locations.length === 0 ? (
//           <EmptyBox message="No locations found for this division." />
//         ) : isMobile ? (
//           // ── Mobile ──
//           <Box>
//             {locations.map((loc) => {
//               const emps         = employeesMap[loc.LocationCode] || [];
//               const isLoadingLoc = loadingLocations[loc.LocationCode];
//               const isExpanded   = expandedRow === loc.LocationCode;

//               return (
//                 <Box key={loc.LocationCode}>
//                   {isLoadingLoc && isExpanded ? (
//                     <Box sx={{ mb: 1.5 }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, bgcolor: '#330066', borderRadius: '14px 14px 0 0' }}>
//                         <Avatar sx={{ width: 36, height: 36, bgcolor: 'rgba(255,255,255,0.2)', flexShrink: 0 }}>
//                           <LocationOn sx={{ fontSize: 18, color: '#fff' }} />
//                         </Avatar>
//                         <Typography sx={{ flex: 1, fontWeight: 700, fontSize: '0.88rem', color: '#fff' }}>{loc.LocationCode}</Typography>
//                       </Box>
//                       <Box sx={{ border: '1.5px solid #330066', borderTop: 'none', borderRadius: '0 0 14px 14px', p: 3, display: 'flex', justifyContent: 'center' }}>
//                         <CircularProgress size={24} sx={{ color: '#330066' }} />
//                       </Box>
//                     </Box>
//                   ) : (
//                     <MobileLocationPanel
//                       location={loc}
//                       employees={emps}
//                       isExpanded={isExpanded}
//                       onToggle={handleToggleLocation}
//                       onViewAll={handleViewDetails}
//                       onEmployeeClick={handleEmployeeClick}
//                       panelRef={(el) => { rowRefs.current[loc.LocationCode] = el; }}
//                     />
//                   )}
//                 </Box>
//               );
//             })}
//           </Box>
//         ) : (
//           // ── Desktop ──
//           <DesktopLocationTable
//             locations={locations}
//             employees={employeesMap}
//             expandedRow={expandedRow}
//             onExpand={handleToggleLocation}
//             onViewDetails={handleViewDetails}
//             onEmployeeClick={handleEmployeeClick}
//             rowRefs={rowRefs}
//           />
//         )}
//       </Paper>

//       <DetailDrawer
//         open={drawerOpen}
//         onClose={() => { setDrawerOpen(false); setTimeout(() => setDrawerData(null), 300); }}
//         data={drawerData}
//         onEmployeeClick={handleEmployeeClick}
//       />

//       <EmployeeDetailDrawer
//         open={empDetailOpen}
//         onClose={() => { setEmpDetailOpen(false); setTimeout(() => setSelectedEmployee(null), 300); }}
//         employee={selectedEmployee}
//       />
//     </>
//   );
// };

import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useLocation } from "react-router-dom";
// import EmployeeDetailDrawer from './EmployeeDetailDrawer';
import AttendanceService from '../../service/AttendanceService';
import {
  Box,
  Typography,
  Paper,
  Collapse,
  Avatar,
  CircularProgress,
  Breadcrumbs,
  Link,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  KeyboardArrowDown,
  CheckCircle,
  Cancel,
  LocationOn,
  AccountTree,
  NavigateNext,
} from '@mui/icons-material';

// ─── Helpers ──────────────────────────────────────────────────────────────────
const todayISO = () => new Date().toISOString().split('T')[0];

const isPresent = (emp) =>
  emp.InTime && emp.InTime !== '' && emp.InTime !== null;

// ─── Chart color helpers ───────────────────────────────────────────────────────
const rateColor = (pct) =>
  pct >= 80 ? '#16a34a' : pct >= 60 ? '#d97706' : '#dc2626';

const rateBg = (pct) =>
  pct >= 80 ? '#dcfce7' : pct >= 60 ? '#fef3c7' : '#fee2e2';

// ─── Percentage Badge ──────────────────────────────────────────────────────────
const PctBadge = ({ pct }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-block',
      px: '7px',
      py: '1px',
      borderRadius: '10px',
      fontSize: 11,
      fontWeight: 600,
      background: rateBg(pct),
      color: rateColor(pct),
      flexShrink: 0,
    }}
  >
    {pct}%
  </Box>
);

// ─── Loading Placeholder ───────────────────────────────────────────────────────
const LoadingBox = ({ message = 'Loading…' }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6, gap: 2 }}>
    <CircularProgress sx={{ color: '#330066' }} size={32} />
    <Typography sx={{ color: '#64748b', fontSize: '0.85rem' }}>{message}</Typography>
  </Box>
);

// ─── Empty Placeholder ─────────────────────────────────────────────────────────
const EmptyBox = ({ message }) => (
  <Box sx={{ textAlign: 'center', py: 6 }}>
    <Typography sx={{ color: '#94a3b8', fontSize: '0.85rem' }}>{message}</Typography>
  </Box>
);

// ─── Step 1: Division Overview Chart ──────────────────────────────────────────
// Fetches location counts for every division in parallel, sums Emp_Total /
// Emp_real, then renders a bar chart identical in style to InlineLocationChart.
// Clicking a bar drills down to that division's location view.
const DivisionOverviewChart = ({ divisions, onSelect }) => {
  const [chartData,    setChartData]    = useState([]);
  const [loadingChart, setLoadingChart] = useState(true);

  useEffect(() => {
    if (!divisions.length) return;
    let cancelled = false;

    (async () => {
      setLoadingChart(true);
      try {
        const rows = [];
        for (const div of divisions) {
          if (cancelled) break;
          try {
            const res  = await AttendanceService.GetEmpLocationCount(div.DivisionCode, todayISO());
            const list = res?.data?.Data ?? res?.data?.ResultSet ?? res?.data ?? [];
            const arr  = Array.isArray(list) ? list : [];
            const total   = arr.reduce((s, r) => s + Number(r.Emp_Total ?? 0), 0);
            const present = arr.reduce((s, r) => s + Number(r.Emp_real  ?? 0), 0);
            const pct     = total > 0 ? Math.round((present / total) * 100) : 0;
            rows.push({ code: div.DivisionCode, name: div.DivisionName, total, present, pct, div });
          } catch {
            // skip failed division, continue with next
          }
        }
        if (!cancelled) {
          setChartData(rows.sort((a, b) => b.total - a.total));
        }
      } finally {
        if (!cancelled) setLoadingChart(false);
      }
    })();

    return () => { cancelled = true; };
  }, [divisions]);

  if (loadingChart) return <LoadingBox message="Loading division overview…" />;
  if (!chartData.length) return <EmptyBox message="No division data available." />;

  const maxTotal      = Math.max(...chartData.map((r) => r.total), 1);
  const totalStrength = chartData.reduce((s, r) => s + r.total,   0);
  const totalPresent  = chartData.reduce((s, r) => s + r.present, 0);
  const overallPct    = totalStrength > 0 ? Math.round((totalPresent / totalStrength) * 100) : 0;

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: '16px',
        background: '#fff',
        border: '1.5px solid #e2e8f0',
        boxShadow: '0 2px 12px rgba(51,0,102,0.06)',
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Box>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#330066', letterSpacing: '0.03em' }}>
            Division Overview
          </Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#94a3b8', mt: '1px' }}>
            {chartData.length} divisions · click bar to view locations
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'right' }}>
          <Typography sx={{ fontSize: '0.65rem', color: '#64748b' }}>
            {totalPresent}/{totalStrength} present
          </Typography>
          <PctBadge pct={overallPct} />
        </Box>
      </Box>

      {/* Bars */}
      {chartData.map((row) => {
        const strengthBarW  = Math.round((row.total   / maxTotal) * 100);
        const attendBarW    = Math.round((row.present / maxTotal) * 100);
        const color         = rateColor(row.pct);

        return (
          <Box
            key={row.code}
            onClick={() => onSelect(row.div)}
            sx={{
              mb: '6px',
              '&:last-child': { mb: 0 },
              cursor: 'pointer',
              borderRadius: '8px',
              p: '6px 8px',
              mx: '-8px',
              border: '1.5px solid transparent',
              transition: 'background 0.15s',
              '&:hover': { bgcolor: '#f3eeff' },
            }}
          >
            {/* Label row */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '4px' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                <Avatar sx={{ width: 20, height: 20, bgcolor: '#ede8f5', flexShrink: 0 }}>
                  <AccountTree sx={{ fontSize: 11, color: '#330066' }} />
                </Avatar>
                <Typography
                  sx={{
                    fontSize: '0.72rem',
                    fontWeight: 600,
                    color: '#1e293b',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {row.code}
                </Typography>
                {row.name && (
                  <Typography
                    sx={{
                      fontSize: '0.65rem',
                      color: '#94a3b8',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    · {row.name}
                  </Typography>
                )}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0, ml: 1 }}>
                <Typography sx={{ fontSize: '0.68rem', color: '#64748b' }}>
                  {row.present}/{row.total}
                </Typography>
                <PctBadge pct={row.pct} />
                <KeyboardArrowDown sx={{ fontSize: 14, color: '#94a3b8' }} />
              </Box>
            </Box>

            {/* Strength bar (background) + Attendance bar (foreground) */}
            <Box sx={{ position: 'relative', height: 5, borderRadius: '10px', background: '#f1f5f9', overflow: 'hidden' }}>
              {/* strength track */}
              <Box
                sx={{
                  position: 'absolute',
                  left: 0, top: 0, bottom: 0,
                  width: `${strengthBarW}%`,
                  borderRadius: '10px',
                  background: '#e2e8f0',
                  transition: 'width 0.4s ease',
                }}
              />
              {/* attendance fill */}
              <Box
                sx={{
                  position: 'absolute',
                  left: 0, top: 0, bottom: 0,
                  width: `${attendBarW}%`,
                  borderRadius: '10px',
                  background: color,
                  transition: 'width 0.4s ease',
                  minWidth: row.present > 0 ? 4 : 0,
                }}
              />
            </Box>

            {/* Legend hint (first bar only) */}
          </Box>
        );
      })}

      {/* Legend */}
      <Box sx={{ display: 'flex', gap: 2, mt: 1.5, px: '2px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 10, height: 10, borderRadius: '2px', background: '#e2e8f0' }} />
          <Typography sx={{ fontSize: '0.62rem', color: '#94a3b8' }}>Strength</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 10, height: 10, borderRadius: '2px', background: '#16a34a' }} />
          <Typography sx={{ fontSize: '0.62rem', color: '#94a3b8' }}>Attendance</Typography>
        </Box>
      </Box>
    </Box>
  );
};

// ─── Inline Location Chart ─────────────────────────────────────────────────────
// Shows location bars; clicking a bar fetches + expands employee attendance inline.
const InlineLocationChart = React.memo(({
  locations,
  employeesMap,
  loadingLocations,
  onBarClick,
  onEmployeeClick,
}) => {
  const [expandedLoc, setExpandedLoc] = useState(null);

  const chartData = useMemo(() => {
    return locations.map((loc) => {
      const code      = loc.LocationCode;
      const employees = employeesMap[code] || [];
      const total     = employees.length > 0 ? employees.length : (loc.Emp_Total ?? 0);
      const present   = employees.length > 0
        ? employees.filter(isPresent).length
        : (loc.Emp_real ?? 0);
      const pct       = loc.Percentage != null
        ? Math.round(loc.Percentage)
        : (total > 0 ? Math.round((present / total) * 100) : 0);
      return { code, employees, total, present, pct };
    });
  }, [locations, employeesMap]);

  const maxTotal      = Math.max(...chartData.map((r) => r.total), 1);
  const totalStrength = chartData.reduce((s, r) => s + r.total,   0);
  const totalPresent  = chartData.reduce((s, r) => s + r.present, 0);
  const overallPct    = totalStrength > 0 ? Math.round((totalPresent / totalStrength) * 100) : 0;

  if (chartData.length === 0) return null;

  const handleBarClick = (code) => {
    const isOpening = expandedLoc !== code;
    setExpandedLoc(isOpening ? code : null);
    onBarClick(code, isOpening);
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: '16px',
        background: '#fff',
        border: '1.5px solid #e2e8f0',
        boxShadow: '0 2px 12px rgba(51,0,102,0.06)',
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Box>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#330066', letterSpacing: '0.03em' }}>
            Location Overview
          </Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#94a3b8', mt: '1px' }}>
            {chartData.length} locations · click bar to expand employees
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'right' }}>
          <Typography sx={{ fontSize: '0.65rem', color: '#64748b' }}>
            {totalPresent}/{totalStrength} present
          </Typography>
          <PctBadge pct={overallPct} />
        </Box>
      </Box>

      {/* Bars + inline employee attendance dropdown */}
      {chartData.map((row) => {
        const barW      = Math.max(Math.round((row.present / maxTotal) * 100), row.present > 0 ? 2 : 0);
        const isOpen    = expandedLoc === row.code;
        const color     = rateColor(row.pct);
        const isLoading = loadingLocations[row.code];

        return (
          <Box key={row.code} sx={{ mb: '6px', '&:last-child': { mb: 0 } }}>

            {/* ── Bar row (clickable) ── */}
            <Box
              onClick={() => handleBarClick(row.code)}
              sx={{
                cursor: 'pointer',
                borderRadius: isOpen ? '8px 8px 0 0' : '8px',
                p: '6px 8px',
                mx: '-8px',
                border: isOpen ? `1.5px solid ${color}` : '1.5px solid transparent',
                borderBottom: isOpen ? 'none' : undefined,
                bgcolor: isOpen ? `${color}0d` : 'transparent',
                transition: 'background 0.15s ease, border-color 0.15s ease',
                '&:hover': { bgcolor: isOpen ? `${color}0d` : '#f3eeff' },
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '4px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px', minWidth: 0, flex: 1 }}>
                  <LocationOn sx={{ fontSize: 12, color: isOpen ? color : '#330066', flexShrink: 0 }} />
                  <Typography
                    sx={{
                      fontSize: '0.72rem', fontWeight: 600, color: '#1e293b',
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}
                  >
                    {row.code}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, ml: 1 }}>
                  <Typography sx={{ fontSize: '0.65rem', color: '#64748b' }}>
                    {row.present}/{row.total}
                  </Typography>
                  <PctBadge pct={row.pct} />
                  <KeyboardArrowDown
                    sx={{
                      fontSize: 14, color: '#94a3b8',
                      transition: 'transform 0.22s ease',
                      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                  />
                </Box>
              </Box>
              {/* Progress bar */}
              <Box sx={{ height: 5, background: '#f1f5f9', borderRadius: '10px', overflow: 'hidden' }}>
                <Box
                  sx={{
                    height: '100%', borderRadius: '10px',
                    width: `${barW}%`, background: color,
                    transition: 'width 0.45s ease',
                  }}
                />
              </Box>
            </Box>

            {/* ── Employee attendance dropdown ── */}
            <Collapse in={isOpen} timeout={220} unmountOnExit>
              <Box
                sx={{
                  mx: '-8px',
                  border: `1.5px solid ${color}`,
                  borderTop: 'none',
                  borderRadius: '0 0 8px 8px',
                  overflow: 'hidden',
                  bgcolor: '#fafbff',
                }}
              >
                {isLoading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                    <CircularProgress size={22} sx={{ color: '#330066' }} />
                  </Box>
                ) : (
                  <>
                    {/* Stats strip */}
                    <Box sx={{ display: 'flex', bgcolor: '#fff', borderBottom: '1px solid #f1f5f9' }}>
                      {[
                        { label: 'Strength', value: row.total,               color: '#330066' },
                        { label: 'Present',  value: row.present,             color: '#16a34a' },
                        { label: 'Absent',   value: row.total - row.present, color: '#dc2626' },
                      ].map((s) => (
                        <Box
                          key={s.label}
                          sx={{
                            flex: 1, textAlign: 'center', py: 1,
                            borderRight: '1px solid #f1f5f9',
                            '&:last-child': { borderRight: 'none' },
                          }}
                        >
                          <Typography sx={{ fontSize: '0.6rem', color: '#64748b' }}>{s.label}</Typography>
                          <Typography sx={{ fontSize: '0.95rem', fontWeight: 800, color: s.color }}>
                            {s.value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    {row.employees.length === 0 ? (
                      <Box sx={{ textAlign: 'center', py: 2.5 }}>
                        <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                          No employee records loaded yet
                        </Typography>
                      </Box>
                    ) : (
                      <>
                        {/* Column headers */}
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1.6fr 1.4fr 0.7fr 0.5fr',
                            gap: 0.5, px: 1.5, py: 0.7,
                            bgcolor: '#ede8f5',
                          }}
                        >
                          {['Svc No', 'Name', 'Designation', 'IN Time', 'Status'].map((h) => (
                            <Typography key={h} sx={{ fontSize: '0.6rem', fontWeight: 700, color: '#330066' }}>
                              {h}
                            </Typography>
                          ))}
                        </Box>

                        {/* Employee rows */}
                        {row.employees.map((emp, idx) => {
                          const p = isPresent(emp);
                          return (
                            <Box
                              key={emp.ServiceNo || idx}
                              onClick={() =>
                                onEmployeeClick({
                                  sno:     emp.ServiceNo,
                                  repname: emp.EmployeeName,
                                  des:     emp.Designation,
                                  inn:     emp.InTime,
                                  pout:    emp.OutTime,
                                })
                              }
                              sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1.6fr 1.4fr 0.7fr 0.5fr',
                                gap: 0.5, px: 1.5, py: 0.85,
                                bgcolor: idx % 2 === 0 ? '#fff' : '#f8faff',
                                borderTop: '0.5px solid #f1f5f9',
                                alignItems: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.18s ease',
                                '&:hover': { bgcolor: '#ede8f5', transform: 'translateX(3px)' },
                              }}
                            >
                              <Typography sx={{ fontSize: '0.65rem', color: '#475569' }}>
                                {emp.ServiceNo || '-'}
                              </Typography>
                              <Typography
                                sx={{ fontSize: '0.65rem', fontWeight: 600, color: '#1e293b', lineHeight: 1.2, wordBreak: 'break-word' }}
                              >
                                {emp.EmployeeName || '-'}
                              </Typography>
                              <Typography
                                sx={{ fontSize: '0.6rem', color: '#64748b', lineHeight: 1.2, wordBreak: 'break-word' }}
                              >
                                {emp.Designation || '-'}
                              </Typography>
                              <Typography
                                sx={{ fontSize: '0.68rem', fontWeight: p ? 700 : 400, color: p ? '#16a34a' : '#dc2626' }}
                              >
                                {p ? emp.InTime : 'Absent'}
                              </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {p
                                  ? <CheckCircle sx={{ fontSize: 14, color: '#16a34a' }} />
                                  : <Cancel     sx={{ fontSize: 14, color: '#dc2626' }} />
                                }
                              </Box>
                            </Box>
                          );
                        })}
                      </>
                    )}
                  </>
                )}
              </Box>
            </Collapse>

          </Box>
        );
      })}

      {/* Legend */}
      <Box
        sx={{
          display: 'flex', gap: 2, justifyContent: 'center',
          pt: '10px', mt: '8px', borderTop: '0.5px solid #f1f5f9',
        }}
      >
        {[
          { label: '≥80%',   color: '#16a34a' },
          { label: '60–79%', color: '#d97706' },
          { label: '<60%',   color: '#dc2626' },
        ].map((l) => (
          <Box key={l.label} sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Box sx={{ width: 7, height: 7, borderRadius: '2px', background: l.color }} />
            <Typography sx={{ fontSize: '0.62rem', color: '#64748b' }}>{l.label}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
});

// ─── Main Export ───────────────────────────────────────────────────────────────
export const DGESatt = ({ data: _ignored, loading: _ignoredLoading }) => {
  const routeLocation = useLocation();

  // Pull division / location from route state (chart drill-down navigation)
  const routeState        = routeLocation?.state ?? {};
  const stateLocationCode = routeState?.location?.location ?? routeState?.location ?? null;
  const stateDivisionCode = routeState?.division ?? null;
  const stateDate         = routeState?.date ?? null;

  // Clear history state on mount so a page refresh shows a clean view
  useEffect(() => {
    if (stateDivisionCode) {
      window.history.replaceState({}, '', window.location.pathname + window.location.search);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── State ──────────────────────────────────────────────────────────────────
  const [view,             setView]             = useState('divisions'); // 'divisions' | 'locations'
  const [divisions,        setDivisions]        = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [locations,        setLocations]        = useState([]);
  const [employeesMap,     setEmployeesMap]     = useState({});
  const [loadingLocations, setLoadingLocations] = useState({});
  const [loading,          setLoading]          = useState(false);
  const [error,            setError]            = useState(null);
  const [empDetailOpen,    setEmpDetailOpen]    = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // ── Utility ────────────────────────────────────────────────────────────────
  const extractArray = (res) => {
    const d = res?.data;
    if (Array.isArray(d))                return d;
    if (d && Array.isArray(d.data))      return d.data;
    if (d && Array.isArray(d.ResultSet)) return d.ResultSet;
    return [];
  };

  // ── Fetch divisions on mount ───────────────────────────────────────────────
  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await AttendanceService.GetAllDivisions();
        if (!cancelled)
          setDivisions(
            extractArray(res).sort((a, b) => a.DivisionCode.localeCompare(b.DivisionCode))
          );
      } catch {
        if (!cancelled) setError('Failed to load divisions. Please try again.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // ── Load locations for a division ─────────────────────────────────────────
  const loadLocations = useCallback(async (divisionCode) => {
    setLocations([]);
    setEmployeesMap({});
    setLoading(true);
    setError(null);
    try {
      const res  = await AttendanceService.GetEmpLocationCount(divisionCode, todayISO());
      const list = res?.data?.Data ?? res?.data?.ResultSet ?? res?.data ?? [];
      setLocations(
        list
          .map((item) => ({
            LocationCode: item.Emp_location,
            LocationName: item.Emp_location,
            Emp_Total:    item.Emp_Total,
            Emp_real:     Number(item.Emp_real),
            Percentage:   item.Percentage,
          }))
          .sort((a, b) => a.LocationCode.localeCompare(b.LocationCode))
      );
    } catch {
      setError('Failed to load locations.');
    } finally {
      setLoading(false);
    }
  }, []);

  // ── Division card clicked ──────────────────────────────────────────────────
  const handleSelectDivision = useCallback(async (div) => {
    setSelectedDivision(div);
    setView('locations');
    await loadLocations(div.DivisionCode);
  }, [loadLocations]);

  // ── Auto-load from route state (chart drill-down navigation) ──────────────
  useEffect(() => {
    if (!stateDivisionCode) return;
    const div = { DivisionCode: stateDivisionCode };
    setSelectedDivision(div);
    setView('locations');
    loadLocations(stateDivisionCode);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateDivisionCode]);

  // ── Back to divisions ──────────────────────────────────────────────────────
  const goToDivisions = useCallback(() => {
    setView('divisions');
    setSelectedDivision(null);
    setLocations([]);
    setEmployeesMap({});
  }, []);

  // ── Bar clicked — fetch employees for that location ────────────────────────
  const handleBarClick = useCallback(async (locationCode, isOpening) => {
    if (!isOpening || !selectedDivision) return;
    if (employeesMap[locationCode] !== undefined) return; // already cached

    setLoadingLocations((prev) => ({ ...prev, [locationCode]: true }));
    try {
      const res = await AttendanceService.GetEmployeesAttendance(
        selectedDivision.DivisionCode,
        locationCode,
        stateDate || todayISO()
      );
      setEmployeesMap((prev) => ({ ...prev, [locationCode]: extractArray(res) }));
    } catch {
      setEmployeesMap((prev) => ({ ...prev, [locationCode]: [] }));
    } finally {
      setLoadingLocations((prev) => ({ ...prev, [locationCode]: false }));
    }
  }, [selectedDivision, stateDate, employeesMap]);

  // ── Employee row clicked → open detail drawer ─────────────────────────────
  const handleEmployeeClick = useCallback((emp) => {
    setSelectedEmployee(emp);
    setEmpDetailOpen(true);
  }, []);

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: '20px', boxShadow: '0 4px 24px rgba(51,0,102,0.06)' }}>
        <Typography
          variant="h6"
          sx={{ mb: 1.5, fontWeight: 700, color: '#330066', fontSize: { xs: '1rem', sm: '1.2rem' } }}
        >
          Based on Designation and Location
        </Typography>

        {/* Breadcrumb navigation */}
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          sx={{ mb: 2.5, '& .MuiBreadcrumbs-ol': { flexWrap: 'wrap' } }}
        >
          <Link
            component="button"
            underline={view === 'divisions' ? 'none' : 'hover'}
            onClick={view !== 'divisions' ? goToDivisions : undefined}
            sx={{
              fontSize: '0.8rem',
              fontWeight: view === 'divisions' ? 700 : 400,
              color: view === 'divisions' ? '#330066' : '#64748b',
              cursor: view === 'divisions' ? 'default' : 'pointer',
              bgcolor: 'transparent', border: 'none', p: 0,
            }}
          >
            Divisions
          </Link>
          {selectedDivision && (
            <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#330066' }}>
              {selectedDivision.DivisionCode}
            </Typography>
          )}
        </Breadcrumbs>

        {/* Body */}
        {loading ? (
          <LoadingBox message={view === 'divisions' ? 'Loading divisions…' : 'Loading locations…'} />
        ) : error ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="error" sx={{ mb: 1.5, fontSize: '0.85rem' }}>{error}</Typography>
          </Box>
        ) : view === 'divisions' ? (
          divisions.length === 0
            ? <EmptyBox message="No divisions found." />
            : <DivisionOverviewChart divisions={divisions} onSelect={handleSelectDivision} />
        ) : locations.length === 0 ? (
          <EmptyBox message="No locations found for this division." />
        ) : (
          <InlineLocationChart
            locations={locations}
            employeesMap={employeesMap}
            loadingLocations={loadingLocations}
            onBarClick={handleBarClick}
            onEmployeeClick={handleEmployeeClick}
          />
        )}
      </Paper>

      {/* <EmployeeDetailDrawer
        open={empDetailOpen}
        onClose={() => { setEmpDetailOpen(false); setTimeout(() => setSelectedEmployee(null), 300); }}
        employee={selectedEmployee}
      /> */}
    </>
  );
};